/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/Age/Content"
  
}) {
let patientPersonBirthDateValueData = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'person.birth_date',
format: fromFormat.ageInYearsAndMonths,
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsNeutral700}
 data="patient.person.birth_date"
 format="/Data/format.js ageInYearsAndMonths"
 text={patientPersonBirthDateValueData}
/>
{children}
</React.Fragment>)
}